import { Box, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

function Error() {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Alert severity="error">{t('common.messages.generic.error')}</Alert>
    </Box>
  );
}

export default Error;
